import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
/* eslint-disable react/prop-types */
import React, { Component } from 'react';

import { Logo, PrimaryPanel, InfoPanel, ActionArea, SecondaryPanel } from '../../header-kit';
import SearchContext from './../SearchContext';

var HeaderDesktop = function (_Component) {
  _inherits(HeaderDesktop, _Component);

  function HeaderDesktop() {
    _classCallCheck(this, HeaderDesktop);

    return _possibleConstructorReturn(this, (HeaderDesktop.__proto__ || _Object$getPrototypeOf(HeaderDesktop)).apply(this, arguments));
  }

  _createClass(HeaderDesktop, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          headerConfig = _props.headerConfig,
          searchOpen = _props.searchOpen,
          onSearchOpen = _props.onSearchOpen,
          onSearchClose = _props.onSearchClose,
          _props$subNavCustom = _props.subNavCustom;
      _props$subNavCustom = _props$subNavCustom === undefined ? {} : _props$subNavCustom;
      var color = _props$subNavCustom.color,
          background = _props$subNavCustom.background,
          storeActionAreaRef = _props.storeActionAreaRef;
      var logo = headerConfig.logo,
          actions = headerConfig.actions,
          productNav = headerConfig.productNav,
          subNavStart = headerConfig.subNavStart,
          subNavEnd = headerConfig.subNavEnd,
          search = headerConfig.search,
          info = headerConfig.info;

      var _ref = subNavStart || {},
          _ref$props = _ref.props;

      _ref$props = _ref$props === undefined ? {} : _ref$props;
      var subNavStartItems = _ref$props.children;

      var _ref2 = subNavEnd || {},
          _ref2$props = _ref2.props;

      _ref2$props = _ref2$props === undefined ? {} : _ref2$props;
      var subNavEndItems = _ref2$props.children;

      var hasSecondaryPanel = !!(subNavStartItems || subNavEndItems);

      var searchContextValue = {
        mobile: false,
        searchHasAdditionalOffset: hasSecondaryPanel
      };

      var headerInfo = info ? React.createElement(
        InfoPanel,
        null,
        info
      ) : null;

      var headerTop = React.createElement(
        PrimaryPanel,
        { narrow: true },
        React.createElement(
          'div',
          { className: 'sb-header__section sb-header__section--shrinkable' },
          logo || React.createElement(Logo, { slot: 'logo', url: '/' }),
          productNav
        ),
        actions.length || search ? React.createElement(
          ActionArea,
          {
            actions: actions,
            open: searchOpen,
            onOpen: onSearchOpen,
            onClose: onSearchClose,
            ref: storeActionAreaRef
          },
          search && React.createElement(
            SearchContext.Provider,
            { value: searchContextValue },
            search
          )
        ) : null
      );

      var headerBottom = hasSecondaryPanel ? React.createElement(
        SecondaryPanel,
        { background: background, color: color },
        subNavStartItems && subNavStart,
        subNavEndItems && subNavEnd
      ) : null;

      return React.createElement(
        'div',
        { className: 'sb-header' },
        headerInfo,
        React.createElement(
          'div',
          { key: 'st', className: 'sb-header__headerTop', 'data-test-id': 'layout.header-top' },
          headerTop
        ),
        React.createElement(
          'div',
          { key: 'nd', className: 'sb-header__headerBottom', 'data-test-id': 'layout.header-bottom' },
          headerBottom
        )
      );
    }
  }]);

  return HeaderDesktop;
}(Component);

export default HeaderDesktop;
//# sourceMappingURL=HeaderDesktop.js.map